export const formatTime = (seconds) => {
  if (!seconds || Number.isNaN(seconds)) return '0:00';
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${s.toString().padStart(2, '0')}`;
};

const EVENT_LABELS = {
  nikkah: 'Nikkah highlights', mehndi: 'Mehndi highlights', reception: 'Reception highlights', haldi: 'Haldi highlights',
  jaggo: 'Jaggo highlights', shaadi: 'Shaadi highlights', sangeet: 'Sangeet highlights', baraat: 'Baraat highlights',
  walima: 'Walima highlights', anand: 'Anand Karaj highlights', teaser: 'Teaser', 'same-day': 'Same-day edit',
};

// Film type for the title plate — never a bare tag on footage.
export const filmTypeLabel = (film) => {
  const tags = (film?.tags || []).map((t) => String(t).toLowerCase());
  for (const t of tags) if (EVENT_LABELS[t]) return EVENT_LABELS[t];
  return 'Wedding highlights';
};

export const isValidLogoUrl = (url) =>
  !!url && (url.includes('cloudfront.net') || url.includes('amazonaws.com') || url.includes('crystalmedia') || url.includes('r2.dev') || url.startsWith('/'));

export const DEFAULT_TAGS = [
  { id: '1', name: 'pakistani', display_name: 'Pakistani' }, { id: '2', name: 'nikkah', display_name: 'Nikkah' },
  { id: '3', name: 'shaadi', display_name: 'Shaadi' }, { id: '4', name: 'reception', display_name: 'Reception' },
  { id: '5', name: 'jaggo', display_name: 'Jaggo' }, { id: '6', name: 'haldi', display_name: 'Haldi' },
  { id: '7', name: 'mehndi', display_name: 'Mehndi' }, { id: '8', name: 'hindu', display_name: 'Hindu' },
  { id: '9', name: 'sikh', display_name: 'Sikh' }, { id: '10', name: 'mixed', display_name: 'Mixed' },
  { id: '11', name: 'fusion', display_name: 'Fusion' },
];

export const sortFilms = (films, selectedTags) => {
  if (!selectedTags.length) {
    return [...films].sort((a, b) => {
      if (a.is_featured && !b.is_featured) return -1;
      if (!a.is_featured && b.is_featured) return 1;
      return (b.priority || 0) - (a.priority || 0);
    });
  }
  const scored = films
    .map((film) => ({ film, matchCount: film.tags ? film.tags.filter((t) => selectedTags.includes(t)).length : 0 }))
    .filter(({ matchCount }) => matchCount > 0)
    .sort((a, b) => (b.matchCount !== a.matchCount ? b.matchCount - a.matchCount : (b.film.priority || 0) - (a.film.priority || 0)))
    .map(({ film }) => film);
  return scored.length ? scored : sortFilms(films, []);
};

export const hasTagMatch = (films, selectedTags) =>
  !selectedTags.length || films.some((f) => (f.tags || []).some((t) => selectedTags.includes(t)));

export const parseTagsParam = (search) => {
  const raw = new URLSearchParams(search).get('tags');
  return raw ? raw.split(',').map((t) => t.trim().toLowerCase()).filter(Boolean) : [];
};

const FILMS_CACHE_KEY = 'cm_films_v1';
export const readFilmsCache = () => {
  try { const raw = sessionStorage.getItem(FILMS_CACHE_KEY); return raw ? JSON.parse(raw) : null; } catch (_) { return null; }
};
export const writeFilmsCache = (films) => { try { sessionStorage.setItem(FILMS_CACHE_KEY, JSON.stringify(films)); } catch (_) { /* quota */ } };
